import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import FlexRow, { FlexRowProps } from './FlexRow';

export interface BreadCrumbsProps extends FlexRowProps {
  pages:			string[][];
  fontSize?:		string;
}

const BreadCrumbs = (props: BreadCrumbsProps) => {
  const fs =	props.fontSize === undefined
  				?	"r32"
  				:	props.fontSize;
  
  return (
  <FlexRow flex={0}>
    {props.pages.map((page: string[], i: number) => {
      const last = i + 1 >= props.pages.length;
      const caption =	page[1] +
                     	(	last
                     		?	''
                     		:	' / '
                     	);
                     		
      const label =
      <span key={i}
            className={[
              last ? '!text-black' : 'text-[--Dark-Grey]',
              fs,
              'leading-normal',
              'tracking-[0.15px]',
            ].join(" ")}>
        { caption }
      </span>;
      
      const output =
      	last
		?	label
		:	<Link to={page[0]}
		          key={i}>
			  { label }
			</Link>;
      
      return output;
    })}
  </FlexRow>
  );
}

export default BreadCrumbs;


